import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * LanguageRoute
 *
 * Wraps a route rendered at `/en/*` or `/it/*` and forces i18next into the
 * requested language on mount / when the URL prefix changes.  This gives us
 * predictable SEO URLs (Google indexes `/en/store` as English) while the
 * unprefixed URLs (`/store`) remain the auto-detected default for humans.
 *
 * NOTE: We intentionally DO NOT write to localStorage here — the URL-based
 * language is temporary for that navigation.  If the visitor explicitly picks
 * a language via `LanguageSelector`, that call writes localStorage.
 */
export default function LanguageRoute({ lang, children }) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!lang) return;
    const current = (i18n.language || "").split("-")[0];
    if (current !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);
  return children;
}
